module.exports = __webpack_public_path__ + "img/new_03.308481d4.jpg";